import { IconName } from '@eluve/components';

export type AdminNavItem = {
  to: string;
  label: string;
  icon: IconName;
};

export const adminNavGroups: AdminNavItem[][] = [
  [
    { to: '/admin/organizations', label: 'Organizations', icon: 'Building2' },
    { to: '/admin/users', label: 'Users', icon: 'Users' },
  ],
  [
    { to: '/admin/prompts', label: 'Prompts', icon: 'MessageSquareQuote' },
    {
      to: '/admin/output-templates',
      label: 'Output Templates',
      icon: 'LayoutTemplate',
    },
    {
      to: '/admin/template-bundles',
      label: 'Template Bundles',
      icon: 'Package',
    },
    {
      to: '/admin/conversation-starters',
      label: 'Conversation Starters',
      icon: 'MessageSquarePlus',
    },
    { to: '/admin/models', label: 'Models', icon: 'Sparkles' },
    { to: '/admin/experiments', label: 'Experiments', icon: 'FlaskConical' },
  ],
  [
    { to: '/admin/on-call', label: 'On-Call', icon: 'Phone' },
    { to: '/admin/site-banners', label: 'Site Banners', icon: 'Bell' },
    { to: '/admin/audit-trail', label: 'Audit Trail', icon: 'History' },
    {
      to: '/admin/global-feature-flags',
      label: 'Global Feature Flags',
      icon: 'FlagTriangleRight',
    },
  ],
  [
    { to: '/admin/medplum', label: 'Medplum', icon: 'Stethoscope' },
    {
      to: '/admin/patient-imports',
      label: 'Import Patients',
      icon: 'Upload',
    },
    { to: '/admin/test-email', label: 'Test Email', icon: 'Mail' },
    { to: '/admin/api-tokens', label: 'API Tokens', icon: 'Lock' },
    {
      to: '/admin/fact-verification',
      label: 'Fact Verification',
      icon: 'SquareCheckBig',
    },
    { to: '/admin/reviewers-list', label: 'Reviewers', icon: 'UserCheck' },
    {
      to: '/admin/ml-engineers-list',
      label: 'ML Engineers',
      icon: 'WandSparkles',
    },
    {
      to: '/admin/billing-codes',
      label: 'Billing Codes',
      icon: 'FileText',
    },
  ],
];

export const adminNav: AdminNavItem[] = adminNavGroups.flat();
